/** Auto-generated by scripts/stamp-version.mjs — do not edit by hand at deploy time. */
export const APP_VERSION = {
  "buildId": "build-1793793532832",
  "version": "21.0.0",
  "builtAt": "2026-11-04T11:58:52.832Z"
} as const;
